module.exports = __webpack_public_path__ + "static/media/contract_template_p2.25bb23b3.jpg";